import type { ClientToServerEvents, LiveAuth, ServerToClientEvents } from "@hali-shares/deck-schema";
import { type Socket, io } from "socket.io-client";

export type LiveSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

/** Namespace /live on the same origin. Reconnects on its own; the server re-sends absolute state. */
export function connectLive(auth: LiveAuth): LiveSocket {
  return io("/live", { auth, withCredentials: true, transports: ["websocket", "polling"] });
}
